<!-- <div class="container-fluid  ">
  <div class="col-md-12 d-flex fixed-header">
    <div class="col-12 col-md-8 d-flex justify-content-between align-items-center mb-2 mb-md-0">
      <app-pagetitle title="{{ deviceName }} : {{ deviceType }}" [breadcrumbItems]="breadCrumbItems"
        [deviceInfo]="true">
      </app-pagetitle>
    </div>

    <div
      class="col-12 col-md-4 d-flex justify-content-between justify-content-md-end align-items-center gap-2 mb-2 mb-md-0">
      <button (click)="refreshData()" type="button" class="btn btn-success small" title="Click to Get Live Data">
        <i class="ri-refresh-line text-dark align-middle mt-5 display-6"></i>
        Refresh
      </button>
      <button (click)="backbtn('backToDashboard')" type="button" class="btn btn-primary ms-2 ml-1 small">
        <Strong>&lt;&lt;</Strong> Back
      </button>
    </div>
  </div>
</div> -->

<div class="container-fluid">
    <div class="row fixed-header align-items-center py-2">
        <div class="col-12 col-md-10 mb-2 mb-md-0 d-flex justify-content-between align-items-center gap-2">
            <select class="form-select neon-text"
                style="font-weight: bold; max-width: 100%; background-color: transparent; border: 0px solid rgba(0, 125, 121, 0.5);"
                [(ngModel)]="params['deviceName']" (click)="onDropdownClick()"
                (change)="handleDeviceSelection($event.target.value)">
                <option *ngFor="let device of deviceList" [value]="device.deviceName">
                    {{device.customerName}} : {{device.deviceName}}
                </option>
            </select>
            <!-- <div class="d-flex d-md-none justify-content-between" *ngIf="isLoopPaused">
                <i (click)="resumeLoop()" title="refresh" class="ri-play-line align-middle"
                    style=" font-size:20px;color:white !important; background-color: #007d79;height: 40px;">
                </i>
            </div> -->
            <button *ngIf="isLoopPaused" (click)="refreshCurrentDevice()" type="button" class="btn btn-success btn-sm"
                title="Refresh current device data">
                <i class="ri-refresh-line align-middle"></i> Refresh
            </button>
            <button *ngIf="isLoopPaused" (click)="resumeLoop()" type="button" class="btn btn-warning btn-sm">
                <i class="ri-play-line align-middle"></i> Release Loop
            </button>
            <!-- <div class="d-flex d-md-none justify-content-between">
                <i (click)="refreshData()" title="refresh" class="ri-refresh-line text-dark display-6 p-2 rounded"
                    style=" font-size:20px;color:white !important; background-color: #007d79;height: 40px;">
                </i>

                <i (click)="backbtn('backToDashboard')" title="back to dashboard"
                    class="ri-logout-box-line text-dark display-6 p-2 rounded"
                    style="font-size:20px;color: white !important; background-color: #007d79;height: 40px; margin-left: 2px;">
                </i>
            </div> -->
        </div>
        <div
            class="col-12 col-md-2 d-none d-md-flex justify-content-between justify-content-md-end align-items-center gap-2">
            <!-- <button (click)="refreshData()" type="button" class="btn btn-success small">
                <i class="ri-refresh-line text-dark align-middle display-6"></i> Refresh
            </button> -->
            <button (click)="logout()" type="button" class="btn btn-primary ms-2 ml-1 small">
                Logout
            </button>
        </div>
    </div>
</div>


<div class="container-fluid mobile-margin-top">
    <div class="row">
        <div class="col-md-8">
            <div class="card" style="height: 200px;">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <div>
                            LUT : {{ epochToHHMMSS(LUT?LUT:0) }}
                        </div>
                        <!-- <div *ngIf="params['configType']!='no_part' && partcountType=='digital' && iscycleData">
                            <ui-switch [(ngModel)]="isChecked" (change)="onSwitchChange($event)"
                                defaultBoColor="#dfdfdf" size="small" color="#f46a6a">
                            </ui-switch>
                        </div> -->
                    </div>
                    <div *ngIf="params['configType']!='no_part'">

                        <div *ngIf="!isChecked && isData" style="pointer-events: none;">
                            <span class="fw-bold" style="display: flex;justify-content: center;align-items: center;"
                                [ngStyle]="{ color: intervalFlag ? 'green' : 'red' }">Hourly Part-Count</span>

                            <app-partcountchart [gaugeArray]="hourlyData" class="chart-container"></app-partcountchart>
                        </div>
                        <div *ngIf="isChecked">
                            <div echarts [options]="cyclegap" class="chart-container"
                                style="width: 100%; height: 200px;"></div>
                        </div>

                        <div *ngIf="showload2"
                            class="d-flex flex-column align-items-center justify-content-center text-center">
                            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)"
                                type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>
                            <span style="margin-top: 50px">Loading</span>
                        </div>
                        <div *ngIf="!isChecked && !showload2" align="center">
                            <p class="mt-2 text-muted">No data available / Fetching data...</p>
                        </div>
                    </div>
                    <div *ngIf="params['configType']=='no_part'" align="center" style="margin-top: 50px">
                        <p> Not Available</p>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card" style="height: 200px;">
                <div class="card-header d-flex align-items-center py-2">
                    <div class="spinner-grow m-1" role="status" [style.color]="statusColor(status)"
                        style="width: 1rem; height: 1rem"></div>
                    <div class="flex-grow-1 text-center" style="color: #007d79; font-weight: bold">
                        {{ currentShift.shiftName }}
                        <span class="d-none d-xl-inline">[ {{ currentShift.startTime }} - {{ currentShift.endTime }}
                            ]</span>
                    </div>
                    <div class="text-right">
                        <h6 class="mb-0" [style.color]="statusColor(status)">{{ currentStatus }}</h6>
                    </div>
                </div>

                <div class="card-body">
                    <div #marque class="marquee" *ngIf="isInsite && !showload">
                        <div class="marquee-content">
                            <ul class="marquee-list">
                                <li class="marquee-item">
                                    {{ currentItem }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="showload"
                        class="d-flex flex-column align-items-center justify-content-center text-center">
                        <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)"
                            type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>
                        <span style="margin-top: 70px">Loading</span>
                    </div>
                    <div class="marquee" style="display: flex; justify-content: center;align-items: center;"
                        *ngIf="!isInsite">
                        Fetching Data
                    </div>
                </div>

                <div class="card-footer py-2">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <strong>Operator:</strong>
                            <span class="highlight-primary">
                                {{ operatorName ? operatorName : "Not Mapped" }}
                            </span>
                        </div>
                        <div class="text-right">
                            <strong>Part:</strong>
                            <span class="highlight-success" *ngIf="params['configType']!='no_part'">
                                {{ partName ? partName : "Not Planned" }}
                            </span>
                            <span class="highlight-success" *ngIf="params['configType']=='no_part'">
                                NA
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-0">
    <div class="row">
        <div class="col-12">
            <div class="card" style="height: fit-content;">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <app-detailedgantt *ngIf="showChart" [gaugeArray]="currentDay" [title]="today2"
                                [shiftData]="allShift" [timeZone]="timeZone">
                            </app-detailedgantt>
                            <div style="display: flex; justify-content: center;align-items: center; height: 100px; width: 100%"
                                *ngIf="!showChart">
                                Fetching Data
                            </div>
                        </div>
                        <div class="col-md-4" style="height: fit-content;">
                            <div class="card-body rounded" style="padding: 8px;border: 1px solid #e0ded8;">
                                <div class="d-flex justify-content-between">
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px;">
                                        <b *ngIf="!liveBool">Total Energy : {{ overAllData[0] &&
                                            overAllData[0].total_Energy || 0 }} KwH</b>
                                        <b *ngIf="liveBool">Total Energy : {{ t_energy || 0}} KwH</b>
                                    </h6>
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px; cursor: pointer;"
                                        title="Click to view hourly Downtime">

                                        <i class="ri-bar-chart-fill downtime-icon"></i>
                                        <b>Downtime : {{ downtimeDurationsHHMMSS[0] }}</b>
                                    </h6>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div class="text-center">
                                        <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1;">
                                            <b *ngIf="params['configType']!='no_part'">Planned Part : {{ overAllData[0]
                                                &&
                                                overAllData[0].total_PlannedPart || 0 }}</b>
                                            <b *ngIf="params['configType']=='no_part'">Planned Part : NA</b>
                                        </p>
                                    </div>
                                    <div class="text-center">
                                        <p *ngIf="params['configType']!='no_part'" class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1; cursor: pointer;"
                                            title="click to view hourly partcount">
                                            <i class="ri-bar-chart-fill downtime-icon"></i>
                                            <b *ngIf="!liveBool && !isPartTwo">Part Count : {{ overAllData[0] &&
                                                overAllData[0]['pin1_count'] || 0}}</b>
                                            <!-- <b *ngIf="!liveBool && isPartTwo">P1 : {{ overAllData[0] && overAllData[0]['partcount'] || 0}} - P2 : {{ overAllData[0] && overAllData[0]['partcount'] || 0}} </b> -->
                                            <b *ngIf="!liveBool && isPartTwo">
                                                <span title="Partcount 1">
                                                    P1 : {{ overAllData && overAllData[0] && overAllData[0].pin1_count
                                                    || 0 }}
                                                </span>
                                                -
                                                <span title="Partcount 2">
                                                    P2 : {{ overAllData && overAllData[0] && overAllData[0].pin2_count
                                                    || 0 }}
                                                </span>
                                            </b>
                                            <b *ngIf="liveBool  && !isPartTwo">Part Count : {{ Ai_partcount || 0}}</b>
                                            <b *ngIf="liveBool  && isPartTwo"> <span title="Partcount 1">
                                                    P1 : {{ Ai_partcount || 0 }}
                                                </span>
                                                -
                                                <span title="Partcount 2">
                                                    P2 : {{ Ai_partcount2 || 0 }}
                                                </span></b>
                                        </p>
                                        <p class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1; cursor: pointer;"
                                            *ngIf="params['configType']=='no_part'">
                                            <b>Part Count : NA</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Energy Cost</p>
                                        <h6 *ngIf="!liveBool" class="mb-0"> ₹ {{overAllData[0] &&
                                            overAllData[0]["energy_cost"] || 0}}</h6>
                                        <h6 *ngIf="liveBool" class="mb-0"> ₹ {{allData && allData["energy_cost"] || 0}}
                                        </h6>

                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Production Cost</p>
                                        <h6 *ngIf="!liveBool" class="mb-0"> ₹ {{overAllData[0] &&
                                            overAllData[0]["production_cost"] || 0}}</h6>
                                        <h6 *ngIf="liveBool" class="mb-0"> ₹ {{allData && allData["production_cost"] ||
                                            0}}</h6>

                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Total Cost</p>
                                        <h6 *ngIf="!liveBool" class="mb-0"> ₹ {{overAllData[0] &&
                                            overAllData[0]["total_cost"] || 0}}</h6>
                                        <h6 *ngIf="liveBool" class="mb-0"> ₹ {{allData && allData["total_cost"] || 0}}
                                        </h6>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-0">
    <div class="row">
        <div class="col-12">
            <div class="card" style="height: fit-content;">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8" style="cursor: pointer;">
                            <app-detailedgantt *ngIf="showChart1" [gaugeArray]="yesterDay" [title]="proviousDay"
                                [shiftData]="allShift" [timeZone]="timeZone"></app-detailedgantt>
                            <div style="display: flex; justify-content: center;align-items: center; height: 100px; width: 100%"
                                *ngIf="!showChart1">
                                Fetching Data
                            </div>
                        </div>
                        <div class="col-md-4" style="height: fit-content;">
                            <div class="card-body rounded" style="padding: 8px;  border: 1px solid #e0ded8;">
                                <div class="d-flex justify-content-between">
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px;">
                                        <b>Total Energy : {{ overAllData[1] && overAllData[1].total_Energy || 0 }}
                                            KwH</b>
                                    </h6>
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px; cursor: pointer;"
                                        title="Click to view hourly Downtime">
                                        <i class="ri-bar-chart-fill downtime-icon"></i>
                                        <b>Downtime : {{ downtimeDurationsHHMMSS[1] }}</b>
                                    </h6>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="text-center">
                                        <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1;">
                                            <b *ngIf="params['configType']!='no_part'">Planned Part : {{ overAllData[1]
                                                &&
                                                overAllData[1].total_PlannedPart || 0 }}</b>
                                            <b *ngIf="params['configType']=='no_part'">Planned Part : NA</b>
                                        </p>
                                    </div>
                                    <div class="text-center">
                                        <p *ngIf="params['configType']!='no_part'" class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1;cursor: pointer;"
                                            title="click to view hourly partcount">
                                            <i class="ri-bar-chart-fill downtime-icon"></i>
                                            <b *ngIf="!isPartTwo">Part Count : {{ overAllData[1] &&
                                                overAllData[1]['pin1_count'] ||0}}</b>
                                            <b *ngIf="isPartTwo">
                                                <span title="Partcount 1">
                                                    P1 : {{ overAllData && overAllData[1] && overAllData[1].pin1_count
                                                    || 0 }}
                                                </span>
                                                -
                                                <span title="Partcount 2">
                                                    P2 : {{ overAllData && overAllData[1] && overAllData[1].pin2_count
                                                    || 0 }}
                                                </span>
                                            </b>
                                        </p>
                                        <p class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1; cursor: pointer;"
                                            *ngIf="params['configType']=='no_part'">
                                            <b>Part Count : NA</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Energy Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[1] && overAllData[1]["energy_cost"] || 0}}
                                        </h6>
                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Production Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[1] && overAllData[1]["production_cost"] || 0}}
                                        </h6>
                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Total Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[1] && overAllData[1]["total_cost"] || 0}}</h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-0">
    <div class="row">
        <div class="col-12">
            <div class="card" style="height: fit-content;">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8" style="cursor: pointer;">
                            <app-detailedgantt *ngIf="showChart1" [gaugeArray]="previousyesterDay"
                                [title]="proviousDay2" [shiftData]="allShift" [timeZone]="timeZone"></app-detailedgantt>
                            <div style="display: flex; justify-content: center;align-items: center; height: 100px; width: 100%"
                                *ngIf="!showChart1">
                                Fetching Data
                            </div>
                        </div>
                        <div class="col-md-4" style="height: fit-content;">
                            <div class="card-body rounded" style="padding: 8px;border: 1px solid #e0ded8;">
                                <div class="d-flex justify-content-between">
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px;">
                                        <b>Total Energy : {{ overAllData[2] && overAllData[2].total_Energy || 0 }}
                                            KwH</b>
                                    </h6>
                                    <h6 style="text-align: center; margin-bottom: 6px; font-size: 12px; cursor: pointer;"
                                        title="Click to view hourly Downtime">
                                        <i class="ri-bar-chart-fill downtime-icon"></i>
                                        <b>Downtime : {{ downtimeDurationsHHMMSS[2] }}</b>
                                    </h6>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div class="text-center">
                                        <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1;">
                                            <b *ngIf="params['configType']!='no_part'">Planned Part : {{ overAllData[2]
                                                &&
                                                overAllData[2].total_PlannedPart || 0 }}</b>
                                            <b *ngIf="params['configType']=='no_part'">Planned Part : NA</b>
                                        </p>
                                    </div>
                                    <div class="text-center">
                                        <p *ngIf="params['configType']!='no_part'" class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1;cursor: pointer;"
                                            title="click to view hourly partcount">
                                            <i class="ri-bar-chart-fill downtime-icon"></i>
                                            <b *ngIf="!isPartTwo">Part Count : {{ overAllData[2] &&
                                                overAllData[2]['pin1_count'] ||
                                                0}}</b>
                                            <b *ngIf="isPartTwo">
                                                <span title="Partcount 1">
                                                    P1 : {{ overAllData && overAllData[2] && overAllData[2].pin1_count
                                                    || 0 }}
                                                </span>
                                                -
                                                <span title="Partcount 2">
                                                    P2 : {{ overAllData && overAllData[2] && overAllData[2].pin2_count
                                                    || 0 }}
                                                </span>
                                            </b>
                                        </p>
                                        <p class="text fw-bold"
                                            style="margin: 4px 0; padding: 2px; line-height: 1; cursor: pointer;"
                                            *ngIf="params['configType']=='no_part'">
                                            <b>Part Count : NA</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Energy Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[2] && overAllData[2]["energy_cost"] || 0}}
                                        </h6>
                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Production Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[2] && overAllData[2]["production_cost"] || 0}}
                                        </h6>
                                    </div>
                                    <div class="text-center">
                                        <p class="fw-semibold mb-1">Total Cost</p>
                                        <h6 class="mb-0"> ₹ {{overAllData[2] && overAllData[2]["total_cost"] || 0}}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #piechart let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Status Chart</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div echarts [options]="chartOptions" class="chart"></div>
    </div>
</ng-template>


<ng-template #currenttemplate let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">{{ getTitle(trendData) }} Trend</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body text-center">
        <div class="partData" *ngIf="trendData === 'partData'">
            <div class="col-md-12 text-center" *ngIf="showHourchart">
                <span class="fw-bold" [ngStyle]="{ color: intervalFlag ? 'green' : 'red' }">Hourly Part-Count</span>
                <app-partcountchart *ngIf="showHourchart" [gaugeArray]="hourlyData2"></app-partcountchart>
            </div>
            <div *ngIf="!showHourchart" align="center">
                <p class="mt-2 text-muted">No data available / Fetching data...</p>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #downtimeTemplate let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">Hourly Downtime Trend</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body text-center">
        <div>
            <div class="col-md-12 text-center">
                <span class="fw-bold">Hourly Downtime</span>
                <div echarts [options]="hourlyDowntimeOption" class="chart"></div>
            </div>
            <!-- <div align="center">
        <p class="mt-2 text-muted">No data available / Fetching data...</p>
      </div> -->
        </div>
    </div>
</ng-template>